module.exports = __webpack_public_path__ + "static/img/1018.260b540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme1/totalBattery/1018.png
// module id = DVBG
// module chunks = 78